import { useState, useEffect } from 'react';

/**
 * Hook для определения текущего breakpoint
 * @returns {'mobile' | 'tablet' | 'desktop'} - текущий breakpoint
 */
const useMediaQuery = () => {
    const getBreakpoint = () => {
        const width = window.innerWidth;
        if (width <= 768) return 'mobile';
        if (width <= 1024) return 'tablet';
        return 'desktop';
    };

    const [breakpoint, setBreakpoint] = useState(getBreakpoint);

    useEffect(() => {
        const handleResize = () => {
            setBreakpoint(getBreakpoint());
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return breakpoint;
};

export default useMediaQuery;
